import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { useSelector } from "react-redux";
import _ from 'lodash';
import { convertValuesFM } from "../../../shared-resources/utils";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    marginTop: 30,
  },
  tableTitle: {
    fontSize: "15px",
    color: "#ffffff",
    backgroundColor: "#01539a",
    lineHeight: "1",
    padding: "8px",
  },
  tableRow: {
    height: 30, // Adjust row height here
  },
  tableCell: {
    padding: "4px 8px", // Reduce padding
    lineHeight: "1.2", // Adjust line height to control text positioning
    verticalAlign: "bottom", // Position text at the bottom
  },
});

export default function EACFunding() {
  const classes = useStyles();
  const { data } = useSelector(
    (state) => state.financialManagementReducer.contractSummaryEACData
  );
  const columns = data?.eac_vs_funding?.[0]?.monthExpenseDetail?.map(({ monthYear }) => monthYear);
  return (
    <TableContainer>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow className={classes.tableTitle}>
            <TableCell className={classes.tableTitle} style={{ width: 300 }}>
              EAC vs. Funding
            </TableCell>
            {columns?.map((column) => <TableCell className={classes.tableTitle} align="right" key={column}>
              {column}
            </TableCell>)}
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.eac_vs_funding?.map((row, index) => (
            <TableRow key={row.type} className={classes.tableRow}>
              <TableCell
                component="th"
                scope="row"
                className={classes.tableCell}
              >
                {_.startCase(row.type)}
              </TableCell>
              {row?.monthExpenseDetail?.map((expense) => <TableCell key={expense?.monthYear} align="right" className={classes.tableCell}>
                {convertValuesFM(expense?.value)}
              </TableCell>)}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
